import type {ws} from '@/types';

export function aopUserIsMatched(o, userId) {
  if (o.hasOwnProperty('accounts_p1')) {
    return !![o.accounts_p1, o.positions_p1].find((items) => items && items[0] && items[0].userID === userId);
  }
  return !![o.accounts, o.positions].find((items) => items && items[0] && items[0].userID === userId);
}

export function findAopUid(o: ws.AOPMsg | ws.AOPMsgV2): number {
  if ((<ws.AOPMsgV2>o).accounts_p1) {
    return (<ws.AOPMsgV2>o).accounts_p1[0]?.userID || (<ws.AOPMsgV2>o).positions_p1[0]?.userID;
  }
  return (<ws.AOPMsg>o).accounts[0]?.userID || (<ws.AOPMsg>o).positions[0]?.userID;
}

export function findMaoUID(o) {
  if (o.wallets.length > 0) {
    return o.wallets[0].userID;
  }
  if (o.orders.closed.length > 0) {
    return o.orders.closed[0].userID;
  }
  if (o.orders.open.length > 0) {
    return o.orders.open[0].userID;
  }
  if (o.orders.fills.length > 0) {
    return o.orders.fills[0].userID;
  }
  return '';
}
